import React, { useState, useEffect } from "react";
import { MDBCol, MDBRow, MDBBtn } from "mdb-react-ui-kit";
import AlertSuccess from "../../AlertSuccess/AlertSuccess";
import axios from "axios";
import InputMask from "react-input-mask";
import Skeleton from "@mui/material/Skeleton";
// config
import configData from "../../../config/config.json";
// images
import youtube from "../../../images/register-business/youtube.png";
import facebook from "../../../images/register-business/facebook.png";
import twitter from "../../../images/register-business/twitter.png";
import instagram from "../../../images/register-business/instagram.png";
import telegram from "../../../images/register-business/telegram.png";
// rtl
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const InformationStep7 = () => {
  const [dataCome, setDataCome] = useState(false);
  // const [socialCome, setSocialCome] = useState(false);
  const [disable, setDisable] = useState(false);
  const [phonestd, setPhonestd] = useState("");

  const [postPhones, setPostPhones] = useState([]);

  const [businessAddId, setBusinessAddId] = useState(0);

  const [CompletePhone, setCompletePhone] = useState({});

  const [newSocialMedia, setnewSocialMedia] = useState([
    {},
    {},
    {},
    {},
    {},
    {},
  ]);
  const [activeSocialName, setActiveSocialName] = useState([]);

  const formatChar = {
    0: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]",
  };

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("phonestd"));
    if (items) {
      setPhonestd(items);
    }
    // console.log(phonestd);
  }, []);

  const socialMHandeler2 = (event, number) => {
    event.preventDefault();

    const nextArray = newSocialMedia.map((c, i) => {
      if (c.smId === number) {
        var x = {
          smId: c.smId,
          icon: c.icon,
          iconPath: c.iconPath,
          title: c.title,
          address: event.target.value,
          bsaId: c.bsaId,
        };
        return x;
      } else {
        return c;
      }
    });

    setnewSocialMedia(nextArray);
  };

  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  const [errorPhone1, seterrorPhone1] = useState("");
  const [errorPhone2, seterrorPhone2] = useState("");
  const [errorPhone3, seterrorPhone3] = useState("");
  const [errorPhone4, seterrorPhone4] = useState("");

  const [data, setData] = useState({
    phonee1: "",
    phonee2: "",
    phonee3: "",
    phonee4: "",
    phonee5: "",
    phonee6: "",
  });
  const [socialM, setsocialM] = useState({
    youtube: "",
    facebook: "",
    twitter: "",
    instagram: "",
    telegram: "",
    linkedin: "",
  });

  const socialMHandeler = (event, number) => {
    event.preventDefault();
    switch (number) {
      case 1:
        event.preventDefault();
        setsocialM({ ...socialM, Youtube: event.target.value });
        break;
      case 2:
        event.preventDefault();
        setsocialM({ ...socialM, facebook: event.target.value });
        break;
      case 3:
        event.preventDefault();
        setsocialM({ ...socialM, twitter: event.target.value });
        break;
      case 4:
        setsocialM({ ...socialM, instagram: event.target.value });
        event.preventDefault();
        break;
      case 5:
        setsocialM({ ...socialM, Telegram: event.target.value });
        event.preventDefault();
        break;
      case 6:
        setsocialM({ ...socialM, linkedin: event.target.value });
        event.preventDefault();
        break;
    }
  };

  const inputChangeHandler = (event) => {
    var result;
    if (event.target.name == "phonee5" || event.target.name == "phonee6") {
      var value = event.target.value;
      result = value.replace(/[^A-Za-z\u0030-\u0039\s,@._-]/g, "");
    } else {
      var value = event.target.value;
      result = value.replace(/[^A-Za-z\u0030-\u0039\s,@.]/g, "");
    }

    setData({ ...data, [event.target.name]: result });
    var num = result.replace(/\D/g, "").length;
    // console.log(result.replace(/\D/g, ""));
    // setPhoneApi({
    //   ...PhoneApi,
    //   [event.target.name]: result.replace(/\D/g, ""),
    // });

    if (num >= 10) {
      switch (event.target.name) {
        case "phonee1":
          seterrorPhone1("");
          break;
        case "phonee2":
          seterrorPhone2("");
          break;
        case "phonee3":
          seterrorPhone3("");
          break;
        case "phonee4":
          seterrorPhone4("");
          break;
      }
    } else if (num == 0) {
      switch (event.target.name) {
        case "phonee1":
          seterrorPhone1("");
          break;
        case "phonee2":
          seterrorPhone2("");
          break;
        case "phonee3":
          seterrorPhone3("");
          break;
        case "phonee4":
          seterrorPhone4("");
          break;
      }
    } else {
      switch (event.target.name) {
        case "phonee1":
          seterrorPhone1("شماره تماس را صحیح وارد کنید.");
          break;
        case "phonee2":
          seterrorPhone2("شماره تماس را صحیح وارد کنید.");
          break;
        case "phonee3":
          seterrorPhone3("شماره فکس را صحیح وارد کنید.");
          break;
        case "phonee4":
          seterrorPhone4("شماره موبایل را صحیح وارد کنید.");
          break;
      }
    }
  };
  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    setnewSocialMedia([{}, {}, {}, {}, {}, {}]);

    setDataCome(false);
    // setSocialCome(false);

    axios
      .get(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/contacts`,
        {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        }
      )
      .then((response) => {
        setnewSocialMedia([]);

        if (response.data.isSuccess) {
          let data = response.data.data;

          setDataCome(true);
          // setSocialCome(true);

          setBusinessAddId(data.baId);
          let p1 = "";
          let p2 = "";
          let p3 = "";
          let p4 = "";

          for (let index = 0; index < data.phones.length; index++) {
            const element = data.phones[index];

            if (element.type == "mobile") {
              p4 = data.phones[index].number;
            } else if (element.type == "fax") {
              p3 = data.phones[index].number;
            } else if (element.type == "phone" && p1 == "") {
              p1 = data.phones[index].number;
            } else if (element.type == "phone" && p1 !== "") {
              p2 = data.phones[index].number;
            }
          }
          setCompletePhone(data.phones);

          setData({
            phonee1: p1,
            phonee2: p2,
            phonee3: p3,
            phonee4: p4,
            phonee5: data.webDetail
              ? data.webDetail.email == null
                ? ""
                : data.webDetail.email
              : "",
            phonee6: data.webDetail
              ? data.webDetail.webSite == null
                ? ""
                : data.webDetail.webSite
              : "",
          });

          setnewSocialMedia(data.socials);
        }
      })
      .catch((error) => {
        // alert(error);
      });
  }, []);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const submitHandler = (event) => {
    event.preventDefault();

    setDisable(true);

    let my_list = [];

    let x;
    for (let index = 0; index < newSocialMedia.length; index++) {
      const element = newSocialMedia[index];
      x = {
        // BizId: getCookie("BizId"),
        bsaId: element.bsaId,
        smId: element.smId,
        address: element.address,
        icon: element.icon,
        iconPath: element.iconPath,
        title: element.title,
      };
      my_list.push(x);
    }

    const aid = JSON.parse(localStorage.getItem("AId")); //set local

    if (data.phonee1 && data.phonee1.length == 16) {
      var x1 = data.phonee1.replace(/\D/g, "");
    } else {
      var x1 = data.phonee1;
    }
    if (data.phonee2 && data.phonee2.length == 16) {
      var x2 = data.phonee2.replace(/\D/g, "");
    } else {
      var x2 = data.phonee2;
    }
    if (data.phonee3 && data.phonee3.length == 16) {
      var x3 = data.phonee3.replace(/\D/g, "");
    } else {
      var x3 = data.phonee3;
    }
    if (data.phonee4 && data.phonee4.length == 16) {
      var x4 = data.phonee4.replace(/\D/g, "");
    } else {
      var x4 = data.phonee4;
    }
    if (data.phonee6.length == 1) {
      var x6 = data.phonee6;
    } else {
      var x6 = data.phonee6;
    }
    if (data.phonee5.length == 1) {
      var x5 = data.phonee5;
    } else {
      var x5 = data.phonee5;
    }

    let PhoneList = [];

    let ph;
    let count = 0;
    for (let index = 0; index < CompletePhone.length; index++) {
      // console.log("-----for");
      // console.log(CompletePhone);
      // console.log(CompletePhone[index]);

      const element = CompletePhone[index];
      switch (element.type) {
        case "phone":
          if (count == 0) {
            ph = {
              baId: element.baId,
              btId: element.btId,
              type: element.type,
              prefixCode: element.prefixCode,
              number_RSA: element.number_RSA,
              number: x1,
              phoneStd: element.phoneStd,
            };
          } else {
            ph = {
              baId: element.baId,
              btId: element.btId,
              type: element.type,
              prefixCode: element.prefixCode,
              number_RSA: element.number_RSA,
              number: x2,
              phoneStd: element.phoneStd,
            };
          }
          count = count + 1;
          break;
        case "fax":
          ph = {
            baId: element.baId,
            btId: element.btId,
            type: element.type,
            prefixCode: element.prefixCode,
            number_RSA: element.number_RSA,
            number: x3,
            phoneStd: element.phoneStd,
          };
          break;
        case "mobile":
          ph = {
            baId: element.baId,
            btId: element.btId,
            type: element.type,
            prefixCode: element.prefixCode,
            number_RSA: element.number_RSA,
            number: x4,
            phoneStd: element.phoneStd,
          };
          break;
      }
      PhoneList.push(ph);
    }

    // var tel = "phone:" + x1 + ";phone:" + x2 + ";fax:" + x3 + ";mobile:" + x4;

    // var countryy = JSON.parse(localStorage.getItem("regStep4")).valueCountry.PrefixCode;
    var countryy = JSON.parse(localStorage.getItem("PrefixCode"));

    const dataPost = {
      bId: getCookie("BizId"),
      baId: businessAddId,
      // baId: aid,
      phones: PhoneList,
      // CountryPerfix: countryy, //aidin dasht
      webSite: x6,
      email: x5,
      socials: my_list,
    };

    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/contacts`,
        dataPost,
        {
          headers: header,
          // "Content-Type": "application/x-www-form-urlencoded",
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // success
          alertHandeler();
        }
      })
      .catch((error) => {
        // alert(error);
      });
  };

  const socialSubmitHandeler = (event) => {
    event.preventDefault();
    // setSocialCome(false);

    for (let index = 0; index < newSocialMedia.length; index++) {
      const element = newSocialMedia[index];
      if (event.target.name == element.title) {
        var add = element.address;
        var smid = element.smId;
      }
    }

    const dataPost2 = {
      bId: getCookie("BizId"),
      smId: smid,
      address: add,
    };

    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/socials`,
        dataPost2,
        {
          headers: header,
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // api to get data of social
          axios
            .get(
              configData.API_DOMAIN +
                `/api/v1/Businesses/${getCookie("BizUuid")}/contacts`,
              {
                headers: {
                  ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
                  LangId: 1,
                  Authorization: "Bearer " + getCookie("token"),
                },
              }
            )
            .then((response) => {
              if (response.data.isSuccess) {
                // success
                alertHandeler();

                setnewSocialMedia([]);

                let data = response.data.data;

                setnewSocialMedia(data.socials);
                // setSocialCome(true);

                for (let index = 0; index < data.socials.length; index++) {
                  const element = data.socials[index];
                  if (element.address != "") {
                    setActiveSocialName(element.title);
                  }
                }
                if (activeSocialName == "") {
                  setActiveSocialName(data.socials[0].title);
                }
              }
            })
            .catch((error) => {
              // alert(error);
            });
        } else {
          // setSocialCome(true);
        }
      })
      .catch((error) => {
        // alert(error);
      });
  };

  return (
    <>
      <div className="part_seven_info">
        <CacheProvider value={cacheRtl}>
          <ThemeProvider theme={theme}>
            {dataCome ? (
              <MDBRow className="w-96-info">
                <MDBCol md="6" size="12">
                  <div className="mb-3">
                    <InputMask
                      formatChars={formatChar}
                      mask={phonestd}
                      // maskChar={null}
                      value={data.phonee1}
                      onChange={inputChangeHandler}
                    >
                      {(inputProps) => (
                        <TextField
                          dir="ltr"
                          type="text"
                          name="phonee1"
                          // value={data.phonee2}
                          onChange={inputChangeHandler}
                          id="outlined-basic"
                          label="شماره تماس"
                          variant="outlined"
                          className={
                            "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 width-100"
                          }
                          {...inputProps}
                        />
                      )}
                    </InputMask>
                    {errorPhone1 && (
                      <span className="input-error-auto me-1">
                        {errorPhone1}
                      </span>
                    )}
                  </div>
                </MDBCol>
                <MDBCol md="6" size="12">
                  <div className="mb-3">
                    <InputMask
                      formatChars={formatChar}
                      mask={phonestd}
                      // maskChar={null}
                      value={data.phonee2}
                      onChange={inputChangeHandler}
                    >
                      {(inputProps) => (
                        <TextField
                          dir="ltr"
                          type="text"
                          name="phonee2"
                          onChange={inputChangeHandler}
                          // value={data.phonee1}
                          id="outlined-basic"
                          label="شماره تماس"
                          variant="outlined"
                          className={
                            "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 width-100"
                          }
                          {...inputProps}
                        />
                      )}
                    </InputMask>
                    {errorPhone2 && (
                      <span className="input-error-auto me-1">
                        {errorPhone2}
                      </span>
                    )}
                  </div>
                </MDBCol>
                <MDBCol md="6" size="12">
                  <div className="mb-3">
                    <InputMask
                      formatChars={formatChar}
                      mask={phonestd}
                      // maskChar={null}
                      value={data.phonee3}
                      onChange={inputChangeHandler}
                    >
                      {(inputProps) => (
                        <TextField
                          dir="ltr"
                          type="text"
                          name="phonee3"
                          // value={data.phonee3}
                          onChange={inputChangeHandler}
                          id="outlined-basic"
                          label="شماره فکس"
                          variant="outlined"
                          className={
                            "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 width-100"
                          }
                          {...inputProps}
                        />
                      )}
                    </InputMask>
                    {errorPhone3 && (
                      <span className="input-error-auto me-1">
                        {errorPhone3}
                      </span>
                    )}
                  </div>
                </MDBCol>
                <MDBCol md="6" size="12">
                  <div className="mb-3">
                    <InputMask
                      formatChars={formatChar}
                      mask={phonestd}
                      // maskChar={null}
                      value={data.phonee4}
                      onChange={inputChangeHandler}
                    >
                      {(inputProps) => (
                        <TextField
                          dir="ltr"
                          type="text"
                          name="phonee4"
                          // value={data.phonee4}
                          onChange={inputChangeHandler}
                          id="outlined-basic"
                          label="شماره موبایل"
                          variant="outlined"
                          className={
                            "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 width-100"
                          }
                          {...inputProps}
                        />
                      )}
                    </InputMask>
                    {errorPhone4 && (
                      <span className="input-error-auto me-1">
                        {errorPhone4}
                      </span>
                    )}
                  </div>
                </MDBCol>

                <MDBCol size="12">
                  <div className="mb-3">
                    <TextField
                      dir="ltr"
                      type="text"
                      name="phonee6"
                      value={data.phonee6}
                      onChange={inputChangeHandler}
                      id="outlined-basic"
                      label="آدرس وبسایت"
                      variant="outlined"
                      className={
                        "label-field-more7 custom-text-field custom-text-field-contact mb-0 width-100 font-family-en"
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <TextField
                      dir="ltr"
                      type="text"
                      name="phonee5"
                      value={data.phonee5}
                      onChange={inputChangeHandler}
                      id="outlined-basic"
                      label="ایمیل"
                      variant="outlined"
                      className={
                        "label-field-more7 custom-text-field custom-text-field-contact mb-0 width-100 font-family-en"
                      }
                    />
                  </div>
                </MDBCol>
              </MDBRow>
            ) : (
              <>
                <div className="d-md-flex ">
                  <Skeleton
                    className="profile-Skeleton-add ms-3"
                    variant="rectangular"
                    height={30}
                    animation="wave"
                  />
                  <Skeleton
                    className="profile-Skeleton-add mt-3 mt-md-0 "
                    variant="rectangular"
                    height={30}
                    animation="wave"
                  />
                </div>
                <div className="d-md-flex ">
                  <Skeleton
                    className="profile-Skeleton-add mt-3 ms-3"
                    variant="rectangular"
                    height={30}
                    animation="wave"
                  />
                  <Skeleton
                    className="profile-Skeleton-add mt-3 "
                    variant="rectangular"
                    height={30}
                    animation="wave"
                  />
                </div>
                <Skeleton
                  className="radius2 mt-3 mb-3"
                  variant="rectangular"
                  height={30}
                  animation="wave"
                />
              </>
            )}
          </ThemeProvider>
        </CacheProvider>
        {/* سوشال مدیا */}
        <div className="">
          <h5 className="header_all_info mt-2 mb-4">سوشال مدیا</h5>
        </div>
        <form action="">
          {newSocialMedia.map((item) =>
            dataCome ? (
              // && socialCome
              <MDBRow className="_so" key={item.smId}>
                <div className="d-flex">
                  <span
                    className={
                      item.bsaId
                        ? "div_img_social_info div_img_social_info_active"
                        : "div_img_social_info"
                    }
                  >
                    <img
                      className="img_social_info"
                      src={item.icon}
                      alt="youtube"
                    />
                  </span>
                  <div className="social-info-input font-family-en">
                    <input
                      className=" mb-3 "
                      type="submit"
                      type="text"
                      placeholder={item.title}
                      value={item.address}
                      onChange={(e) => socialMHandeler2(e, item.smId)}
                    />
                    <MDBBtn
                      className="d-none d-md-inline-block rb-s5-zakhire save_button_so"
                      color="success"
                      onClick={(e) => socialSubmitHandeler(e)}
                      name={item.title}
                    >
                      ذخیره
                    </MDBBtn>
                  </div>
                </div>
              </MDBRow>
            ) : (
              <div className="d-flex justify-content-right  mb-3 me-1 ">
                <Skeleton
                  className=""
                  variant="circular"
                  width={30}
                  height={30}
                  animation="wave"
                />
                <Skeleton
                  className="radius2 me-3 w-100"
                  variant="rectangular"
                  height={30}
                  animation="wave"
                />
              </div>
            )
          )}
        </form>
        <div className="step2_save_c p-0">
          {dataCome ? (
            <button
              onClick={submitHandler}
              disabled={disable}
              className="btn_information_submit"
            >
              ذخیره اطلاعات
            </button>
          ) : (
            <Skeleton
              className="btn_information_submit me-auto"
              variant="rectangular"
              height={39}
              animation="wave"
            />
          )}
        </div>
        {/* alert delete */}
        <AlertSuccess
          showAlert={showAlert}
          text={" اطلاعات شما با موفقیت ثبت شد."}
        />
      </div>
    </>
  );
};

export default InformationStep7;
